'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mailCheck = require('./util/mail-check.js');
var personalIdValidation = require('./util/personal-id-validation.js');
var signUpConstants = require('./sign-up-constants.js');
var menuConstants = require('./menu-constants.js');



exports.mailCheck = mailCheck.mailCheck;
exports.getPersonalIdFormatter = personalIdValidation.getPersonalIdFormatter;
exports.getPersonalIdValidator = personalIdValidation.getPersonalIdValidator;
exports.personalIdFormatters = personalIdValidation.personalIdFormatters;
exports.personalIdValidators = personalIdValidation.personalIdValidators;
Object.defineProperty(exports, 'SIGN_UP_STEPS', {
	enumerable: true,
	get: function () {
		return signUpConstants.SIGN_UP_STEPS;
	}
});
Object.defineProperty(exports, 'TwoFactorAuthMode', {
	enumerable: true,
	get: function () {
		return signUpConstants.TwoFactorAuthMode;
	}
});
exports.VALID_TFA_VALUES = signUpConstants.VALID_TFA_VALUES;
exports.sanitizeTwoFactorAuthModes = signUpConstants.sanitizeTwoFactorAuthModes;
Object.defineProperty(exports, 'AccountPage', {
	enumerable: true,
	get: function () {
		return menuConstants.AccountPage;
	}
});
